import L, { divIcon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import { useChooseContext } from "../context/ChooseContext";
import { useMapContext } from "../context/MapContext";
import { useSelectEarthquakeContext } from "../context/SelectEarthquakeContext";
import Coordinate from "./Coordinate";
import Footer from "./Footer";
import RecentEarthquake from "./RecentEarthquake";
import ShrinkButton from "./ShrinkButton";
import Sidebar from "./Sidebar";
import { Clock, Location, Pulse, Target, Tower } from "./Svg";

export default function Map() {
  const [state] = useSelectEarthquakeContext();
  const [, setMap] = useMapContext();
  const [choose] = useChooseContext();

  const icon = divIcon({
    html: '<div class="map-marker"></div>',
    popupAnchor: [8, 1],
  });
  const Bounds = () => {
    const southWest = L.latLng(-89.98155760646617, -180);
    const northEast = L.latLng(89.99346179538875, 180);
    const bounds = L.latLngBounds(southWest, northEast);
    const map = useMap();
    useEffect(() => {
      map.setMaxBounds(bounds);
      map.addEventListener("drag", () => {
        map.panInsideBounds(bounds, { animate: false });
      });
      return () => {
        map.removeEventListener("drag", () => {
          map.panInsideBounds(bounds, { animate: false });
        });
      };
    });
  };

  return (
    <div className="w-full h-[100vh] relative overflow-hidden">
      {state.isLoading ? (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ">
          <div className="w-6 h-6 bg-slate-600 bounce-spin mx-auto mb-2"></div>
          <p className="text-sm">Loading bang..</p>
        </div>
      ) : (
        <>
          <MapContainer
            ref={setMap}
            center={[
              state.recentEarthquake.Position[0],
              state.recentEarthquake.Position[1],
            ]}
            zoom={5}
            scrollWheelZoom={true}
            style={{ height: "100vh", zIndex: 10 }}
            minZoom={3}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {state.isLoading ? (
              ""
            ) : (
              <Marker
                position={
                  choose.isRecent
                    ? [
                        state.recentEarthquake.Position[0],
                        state.recentEarthquake.Position[1],
                      ]
                    : [
                        state.selectedEarthquake.Position[0],
                        state.selectedEarthquake.Position[1],
                      ]
                }
                icon={icon}
              >
                <Popup maxWidth="300" maxHeight="auto">
                  <div className="flex flex-col w-full gap-3">
                    <div className="w-full border-b text-lg font-bold py-2">
                      {choose.isRecent ? "Gempabumi Terbaru" : "Gempabumi"}
                    </div>
                    <div className="flex gap-10 border-b pb-3">
                      <div className="flex w-full h-full gap-3">
                        <Clock />
                        <div className="flex flex-col">
                          <span className="card-text-date">
                            {choose.isRecent
                              ? state.recentEarthquake.Tanggal
                              : state.selectedEarthquake.Tanggal}
                          </span>
                          <span className="card-text-time">
                            {choose.isRecent
                              ? state.recentEarthquake.Jam
                              : state.selectedEarthquake.Jam}{" "}
                            WIB
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <Pulse size={24} />
                        <span className="card-earthquake-mg">
                          {choose.isRecent
                            ? state.recentEarthquake.Magnitude
                            : state.selectedEarthquake.Magnitude}
                        </span>
                        <span className="card-earthquake-mg-text">
                          Magnitudo
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col gap-4 py-2">
                      {choose.isRecent ? (
                        <div className="flex items-center gap-3">
                          <div className="w-4 h-4">
                            <Tower />
                          </div>
                          <span className="text-slate-900 font-medium">
                            {state.recentEarthquake.Potensi}
                          </span>
                        </div>
                      ) : state.selectedEarthquake.Potensi ? (
                        <div className="flex items-center gap-3">
                          <div className="w-4 h-4">
                            <Tower />
                          </div>
                          <span className="text-slate-900 font-medium">
                            {state.selectedEarthquake.Potensi}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="flex items-center gap-3">
                        <div className="w-4 h-4">
                          <Location />
                        </div>
                        <span className="text-slate-900 font-medium">
                          {choose.isRecent
                            ? state.recentEarthquake.Wilayah
                            : state.selectedEarthquake.Wilayah}
                        </span>
                      </div>
                      {choose.isRecent ? (
                        <div className="flex items-center gap-3">
                          <div className="w-4 h-4">
                            <Target />
                          </div>
                          <span className="text-slate-900 font-medium">
                            {state.recentEarthquake.Dirasakan}
                          </span>
                        </div>
                      ) : state.selectedEarthquake.Dirasakan ? (
                        <div className="flex items-center gap-3">
                          <div className="w-4 h-4">
                            <Target />
                          </div>
                          <span className="text-slate-900 font-medium self-stretch">
                            Dirasakan di {state.selectedEarthquake.Dirasakan}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </Popup>
              </Marker>
            )}

            <Bounds />
          </MapContainer>
          <RecentEarthquake />
          <Coordinate />
          <Sidebar />
          <ShrinkButton />
          <Footer />
          <span className="absolute bottom-5 right-0 block min-[520px]:hidden text-xs px-2 bg-white z-10 opacity-80">
            &copy; 2024, ZEN
          </span>
        </>
      )}
    </div>
  );
}
